import { FC } from 'react'
import { PositionRange } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'
import './ActionsSelection.scss'
import { ActionsSelectionPosition } from './ActionsSelectionPosition'
import { RangeEdge } from '../../enums/RangeEdge'

interface Props {
  range: PositionRange
}

export const ActionsSelection: FC<Props> = ({ range }) => {
  const left = useVisiblePositionPercent(range[0])
  const width = useVisiblePositionPercent(range[1]) - left

  return (
    <div className="ActionsSelection" style={{ left: `${left + width / 2}%`, minWidth: `${width}%` }}>
      <ActionsSelectionPosition position={range[0]} end={range[1]} edge={RangeEdge.Start} />
      <ActionsSelectionPosition position={range[1]} edge={RangeEdge.End} />
    </div>
  )
}
